import React from 'react'
import TranslationTimeCont from '../General/TranslationTimeCont'
import ModalDialogButton from '../Accessibility/ModalDialog/ModalDialogButton'
import ModalDialog from '../Accessibility/ModalDialog/ModalDialog'
import isCurrentPerformance from '../functions/isCurrentPerformance'
import getMomentNow from '../functions/getMomentNow'
import getMomentDateObj from '../functions/getMomentDateObj'
import MovieTimesTicketsModalAccess from './MovieTimesTicketsModalAccess'
import { KINOTICKETS } from '../constants/paymentProvider'
import { MULTICINEMA } from '../constants/multiCinemaModes'
import PerformanceIframeSwitch from '../General/PerformanceIframeSwitch'


const hasIframe = (cinemas, currentCinemaId, performanceCinemaId, clusterCinemaOption) => {
    const currentCinema = cinemas[currentCinemaId]
    let cinemaDataProvider

   if(clusterCinemaOption || currentCinema.scope.type === MULTICINEMA) {
        cinemaDataProvider = cinemas[performanceCinemaId] ? cinemas[performanceCinemaId].scope.cinemaDataProvider : null

    } else {
        cinemaDataProvider = currentCinema.scope.cinemaDataProvider
    }


    return KINOTICKETS !== cinemaDataProvider.type
}



const TicketLink = ({
    uri,
    timeUtc
}) => (
    <a className='ticket-link text-medium"' href={uri} rel="noreferrer" target="_blank">
        <TranslationTimeCont
            id="showtimePerformance"
            timeString={timeUtc}
        />
    </a>
)


const MovieTimesPeriodeDaysItemsAccess = ({
    dayKey,
    alternativeLink,
    performances,
    timezone,
    currentCinemaId,
    clusterCinemaOption,
    cinemas,
    activePerformanceId,
    onToggleActivePerformanceId
}) => {
    const dateNow = getMomentNow(timezone)

    return (
        performances.map(performance => {
            const { id, timeUtc, theatreName, deeplinkURL, attributes, cinema, priceInfo, seatClasses } = performance


            if(!isCurrentPerformance(dateNow, getMomentDateObj(timeUtc, timezone))) {
                return ''
            } else if(alternativeLink) {
                return <TicketLink
                    key={id}
                    uri={alternativeLink}
                    timeUtc={timeUtc}
                />
            } if(!hasIframe(cinemas, currentCinemaId, cinema, clusterCinemaOption)) {
                return <TicketLink
                    key={id}
                    uri={deeplinkURL}
                    timeUtc={timeUtc}
                />
            } else {
                return (
                    <div key={id}>
                        <ModalDialogButton
                            buttonText={<TranslationTimeCont
                                id="showtimePerformance"
                                timeString={timeUtc}
                            />}
                            onClick={() => onToggleActivePerformanceId(id)}
                        />

                        <ModalDialog 
                            isActive={id === activePerformanceId}
                            onClose={() => onToggleActivePerformanceId(false)}
                        >
                            <PerformanceIframeSwitch
                                showId={id}
                                deeplinkURL={deeplinkURL}
                                scrollToPosition={9}
                                cinema={cinema}
                            />
                        </ModalDialog>

                    </div>
                )
            }
        })
    )

}

export default MovieTimesPeriodeDaysItemsAccess